import { useState, useCallback } from 'react';
import { PopularDest } from '../constants/misc.js';

function useTopDest({ max }) {
    const [topDests, _setTopDests] = useState(PopularDest);
    const setTopDests = useCallback((dest) => {
        _setTopDests((state) => {
            if (!state.slice(0, max).find((s) => (s === null || s === void 0 ? void 0 : s.state_id) === (dest === null || dest === void 0 ? void 0 : dest.state_id))) {
                return [dest, ...state];
            }
            else {
                return state;
            }
        });
    }, [topDests]);
    return { topDests, setTopDests };
}

export { useTopDest };
//# sourceMappingURL=useTopDest.js.map
